(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["liquo-discovery-kit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('liquo-discovery-kit')) {
  customElements.define('liquo-discovery-kit', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.events = new AbortController();
      const data = JSON.parse(this.querySelector('[data-kit-data]').textContent);
      const select = this.querySelector('[data-kit-variant]');
      const stickySelect = this.querySelector('[data-kit-sticky-variant]');
      const sticky = this.querySelector('[data-kit-sticky]');
      const primaryAdd = this.querySelector('[data-kit-add]');
      const stickyAdd = this.querySelector('[data-kit-sticky-add]');
      const syncVariant = id => {
        const variant = data.variants.find(item => String(item.id) === String(id));
        if (!variant) return;
        if (select) select.value = String(id);
        if (stickySelect) stickySelect.value = String(id);
        this.querySelector('[data-kit-price]').textContent = variant.price;
        this.querySelector('[data-kit-sticky-price]').textContent = variant.price;
        for (const selector of ['[data-kit-compare]', '[data-kit-sticky-compare]']) {
          const compare = this.querySelector(selector);
          compare.textContent = variant.compare;
          compare.hidden = !variant.sale;
        }
        primaryAdd.disabled = !variant.available;
        primaryAdd.textContent = variant.available ? data.add : data.soldOut;
        stickyAdd.disabled = !variant.available;
        stickyAdd.firstChild.textContent = variant.available ? data.stickyAdd : data.soldOut;
        this.querySelector('[data-kit-stock]').textContent = variant.stock;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      };
      select?.addEventListener('change', () => syncVariant(select.value), {signal:this.events.signal});
      stickySelect?.addEventListener('change', () => syncVariant(stickySelect.value), {signal:this.events.signal});
      const updateSticky = () => {
        const rect = primaryAdd.getBoundingClientRect();
        const visible = rect.bottom < 0;
        sticky.hidden = !visible;
        document.body.classList.toggle('lq-kit-sticky-active', visible);
        const previewBar = document.getElementById('PBarNextFrameWrapper');
        const offset = previewBar ? previewBar.getBoundingClientRect().height : 0;
        this.style.setProperty('--lq-kit-preview-offset', `${offset}px`);
      };
      this.observer = new IntersectionObserver(updateSticky, {threshold:0});
      this.observer.observe(primaryAdd);
      window.addEventListener('resize', updateSticky, {signal:this.events.signal,passive:true});
      window.addEventListener('pageshow', updateSticky, {signal:this.events.signal});
      updateSticky();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      document.body.classList.remove('lq-kit-sticky-active');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liquo-hero-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('liquo-hero-slider')) {
  customElements.define('liquo-hero-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.lq-hero-slides');
      this.slides = Array.from(this.querySelectorAll('.lq-hero-slide'));
      this.dots = Array.from(this.querySelectorAll('.lq-hero-dot'));
      if (!this.track || !this.slides.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.current = 0;
      this.suppressClickUntil = 0;
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.show(index), options);
      });
      this.querySelectorAll('[data-dir]').forEach(button => {
        button.addEventListener('click', () => {
          this.show(this.current + (button.dataset.dir === 'next' ? 1 : -1));
        }, options);
      });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          if (!this.drag) this.update(Math.round(this.track.scrollLeft / this.track.clientWidth));
        });
      }, { ...options, passive: true });
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || this.slides.length < 2) return;
        this.suppressClickUntil = 0;
        this.drag = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          left: this.track.scrollLeft,
          index: this.current,
          active: false
        };
      }, options);
      this.track.addEventListener('pointermove', event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.active) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
          if (Math.abs(dy) > Math.abs(dx)) {
            this.drag = null;
            return;
          }
          drag.active = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.track.scrollLeft = drag.left - dx;
      }, options);
      const finish = event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        this.drag = null;
        this.track.classList.remove('is-dragging');
        if (this.track.hasPointerCapture(drag.id)) this.track.releasePointerCapture(drag.id);
        if (!drag.active) return;
        this.suppressClickUntil = performance.now() + 400;
        const dx = event.clientX - drag.x;
        const threshold = Math.min(80, this.track.clientWidth * 0.15);
        let index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (event.type === 'pointerup' && Math.abs(dx) >= threshold && index === drag.index) {
          index = drag.index + (dx < 0 ? 1 : -1);
        }
        this.show(Math.max(0, Math.min(this.slides.length - 1, index)));
      };
      window.addEventListener('pointerup', finish, options);
      window.addEventListener('pointercancel', finish, options);
      this.track.addEventListener('lostpointercapture', finish, options);
      this.track.addEventListener('click', event => {
        if (performance.now() < this.suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { ...options, capture: true });
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.addEventListener('keydown', event => {
        if (event.target.matches('input, textarea, select, [contenteditable]')) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.lq-hero-slide');
        if (slide) this.show(this.slides.indexOf(slide), 'instant');
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.show(this.current, 'instant'));
      this.resizeObserver.observe(this.track);
      this.update(0);
    }
    update(index) {
      this.current = Math.max(0, Math.min(this.slides.length - 1, index));
      this.slides.forEach((slide, i) => {
        const active = i === this.current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.current);
        dot.setAttribute('aria-current', String(i === this.current));
      });
    }
    show(index, behavior) {
      index = (index + this.slides.length) % this.slides.length;
      this.update(index);
      this.track.scrollTo({
        left: index * this.track.clientWidth,
        behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth')
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
